// Storage Primary Organization IDs
// 이 organization에 속한 사용자는 / 접근 시 /rms_v2로 리다이렉트됩니다.
// /?workflow=xxx, /?conversation_id=xxx 접근은 허용됩니다.

export const STORAGE_PRIMARY_ORG_IDS: string[] = [
  '1ec8b21f-c799-4fbb-a6cc-1548d45334f3', // ArrowPoint
  '1bd3224a-f6fc-4c8e-a354-15df7a06ee53', // CGSI
  'b152baa5-89c9-44b4-92f4-31b0f05b4bb6', // CLSA
  // 'df52b2c0-52fe-441e-9036-a29f21b87365', // Verso LP
]
